import { gql } from '@apollo/client'
import React from 'react'

import { checklistsClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChecklistState = () => React.useContext(Context)
export const useChecklist = () => useChecklistState()?.checklist

const QUERY = gql`
  query Checklist($id: ID) {
    checklist(id: $id, filter: { ignoreSegments: true, includeDisabled: true }) {
      id
      name
      description
      icon
      category
      insertedAt
      updatedAt
      deleted
      allowReview
      allowBulkExecution
      emailNotificationEnabled
      usages
      requireCheckin
      runtime
      configuration
      questions {
        id
        name
        reference
        parentReference
        required
        minPhotos
        description
        data
        tags {
          id
          name
        }
        documents {
          id
          src
          type
          description
        }
        masks {
          id
          name
        }
        photosRequired
        photosFromGallery
        ordination
        categoryOrdination
        private
        data
        expectedCheckboxReply
        displayConditions
        allowNull
        photosEnabled
        notesEnabled
        notesRequired
        defaultValue
        nonComplianceConditions
        options {
          id
          name
          reference
          ordination
        }
        typeName
        type {
          id
          name
        }
        category {
          id
          name
        }
        autofill {
          source
          fieldId
          editable
          updateBase
        }
      }
      type {
        id
        name
      }
    }
  }
`

const ChecklistsLoader = ({ children, id }) => {
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: checklistsClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChecklistsLoader
